import styled from '@emotion/styled';
import { Button } from '@naf-simba/elements-buttons';
import { simbaStyled } from '@naf-simba/theme';
import { Text } from '@naf/text';
import { spacing } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { ArrowForward } from '@styled-icons/material/ArrowForward';
import { isNotTransientProp } from '@lib/shouldForwardProp';

export const ErrorText = styled(Text)`
  color: ${nafColor.information.errorDark};
  margin-top: ${spacing.space8};
  margin-bottom: 0;
`;

export const SubmitButton = simbaStyled(Button)(({ theme }) => ({
  '&&': {
    padding: `${theme.spacing(4)} ${theme.spacing(5)} ${theme.spacing(4)} ${theme.spacing(6)}`,
  },
}));

export const SubmitIcon = styled(ArrowForward)`
  margin-left: ${spacing.space12};
`;

export const CaptionText = styled(Text)`
  margin-top: ${spacing.space8};
  margin-bottom: 0;
`;

export const Label = styled.label`
  display: flex;
  flex-flow: column nowrap;
`;

export const LabelText = styled(Text)`
  margin-top: 0;
  margin-bottom: ${spacing.space8};
`;

export const NameInput = styled.input`
  box-sizing: border-box;
  width: 100%;
  padding: 10px ${spacing.space12};
  margin-bottom: ${spacing.space24};
  border: 1px solid ${nafColor.neutral.neutral4};
  border-radius: 2px;
`;

export const QuestionTextArea = styled.textarea`
  box-sizing: border-box;
  width: 100%;
  height: ${spacing.space80};
  padding: 10px ${spacing.space12};
  border: 1px solid ${nafColor.neutral.neutral4};
  border-radius: 2px;
  resize: none;
`;

export const LetterCounter = styled(Text, { shouldForwardProp: isNotTransientProp })<{ $tooLong: boolean }>`
  margin-top: ${spacing.space8};
  margin-bottom: 0;
  color: ${({ $tooLong }) => ($tooLong ? nafColor.information.errorDark : nafColor.neutral.neutral4)};
  align-self: flex-end;
`;
